import jsPDF from "jspdf"
import when from './functional';

export default {

  lastPosition: 0,

  addWatermark: true,

  isFirstPage: true,

  pageCounter: 1,

  rightPage: false,
  hasOrganic: false,
  hasFairtrade: false,
  hasRainforest: false,


  config: {
    imageHeight: 30,
    pdfDimensions: [297,210],
    innerHeight: 210 - 43,
    innerPageWidth: 297 / 2,
    textMaxWidth: 297 / 2 - 30,
    positions: {
      items: 20,
      price1: 70,
      price2: 85,
      price3: 100,
      price4: 115
    },
    fontSizes: {
      title: 11,
      bigTitle: 12,
      text: 12,
      smallText: 10,
      lineSpacing: 8,
      sectionSpacing: 13
    },
    topPadding: 20

  },
  doc: {},
  state: {},

  pageOffset() {
    return this.rightPage * this.config.innerPageWidth;
  },

  /**
   * Creates the PDF with the given state
   * @param {*} this.state
   */
  createPDF (state, addWatermark) {

    this.lastPosition = 0;
    this.addWatermark = addWatermark;

    this.state = state;

    this.doc = new jsPDF('l', 'mm', this.config.pdfDimensions);

    this.addLogos(true)

    const ccOffsetY = this.state.customCoffees.some(x => this.isOneNotNull(x.oneSize, x.s, x.m,x.l))
                      ? this.addCustomCoffees(30, this.state) - this.config.topPadding
                      : 0;

    const extrasOffsetY = this.state.extras.length > 0
                          ? this.addSection(ccOffsetY + this.config.fontSizes.sectionSpacing, this.state.extras, this.state.extrasTitle.value.toUpperCase()) - this.config.topPadding
                          : ccOffsetY;

    const teasOffsetY = this.state.teas.length > 0 &&
                        this.state.teas.some(x => this.isOneNotNull(x.price))
                        ? this.addSection(extrasOffsetY + this.config.fontSizes.sectionSpacing, this.state.teas, "TEA") - this.config.topPadding
                        : extrasOffsetY;


    let othersOffsetY = this.state.others.length > 0
                        ? this.addOtherSection(teasOffsetY + this.config.fontSizes.sectionSpacing) //- this.config.topPadding
                        : teasOffsetY;

    othersOffsetY = this.checkAddPage(othersOffsetY);

    let nextOffset = othersOffsetY;

    if(this.state.selectedCoffees.length > 0) {

      nextOffset =
          this.addTextTitle(othersOffsetY,
          "Our coffees",
          this.state.texts.ourCoffees,
          true) - this.config.topPadding;
    }


    if (this.state.hasCertifications.value !== "false") {

      this.addCertificationsSection(nextOffset)
    }

    if (this.addWatermark) {

      var totalPages = this.doc.internal.getNumberOfPages();

      for (let i = 1; i <= totalPages; i++) {
        this.doc.setPage(i);
        this.doc.setTextColor("DDDDDD");
        this.doc.setFontSize(100)
        this.doc.setFont("SC")
        this.doc.text("PREVIEW", this.config.pdfDimensions[0] / 2 - 40, this.config.pdfDimensions[1] / 2 + 30, {angle: 45});

        this.doc.setTextColor(0,0,0);
      }
    }
  },

  isOneNotNull(...args) {
    return args.some(x => x !== "" && x !== null && x !== undefined);
  },

  downloadPdf() {
    this.doc.save('Menu.pdf');
  },

  downloadAsDataUri() {
    //this.doc.save('Menu.pdf');
    return this.doc.output("datauristring");
  },

  isNull(value) {
    return value === "" || value === undefined || value === null || value === false;
  },

  addLogos(firstPage = false) {
    if(!this.isNull(this.state.logo.data) && firstPage) {
      const imageWidth = this.config.imageHeight * this.state.logo.ratio;
      this.doc.addImage(this.state.logo.data, "", this.config.innerPageWidth / 2 - imageWidth / 2, 10, imageWidth, this.config.imageHeight);
    }

    this.doc.addImage("/app/themes/matthewalgie/assets/images/logo.jpg",
    "", this.config.pdfDimensions[0] / 4 - 20,  this.config.pdfDimensions[1] - 20,
    40, 339 / 640 * 40)
    this.doc.addImage("/app/themes/matthewalgie/assets/images/logo.jpg",
    "", this.config.pdfDimensions[0] / 4 * 3 - 20,  this.config.pdfDimensions[1] - 20,
    40, 339 / 640 * 40)

  },

  /**
   * Adds the custom coffee section
   * @param {*} offsetY
   * @param {*} this.state
   */
  addCustomCoffees(offsetY) {


    this.setTitle(this.getYPosition(offsetY), "COFFEE")

    this.doc.setFontSize(this.config.fontSizes.text)
    this.doc.setFont("SC")

    this.doc.text("S", this.pageOffset() + this.config.positions.price2, this.getYPosition(offsetY))
    this.doc.text("M", this.pageOffset() + this.config.positions.price3, this.getYPosition(offsetY))
    this.doc.text("L", this.pageOffset() + this.config.positions.price4, this.getYPosition(offsetY))

    this.doc.setFont("regular")

    this.state.customCoffees.filter(x => this.isOneNotNull(x.oneSize, x.s, x.m,x.l)).map((coffee, index) => {
      this.writeCoffee(coffee, this.getItemYOffset(offsetY, index))
    })


    this.hasOrganic =     this.state.selectedCoffees.some(x => x.certifications.some(y => y === "organic"));
    this.hasFairtrade =   this.state.selectedCoffees.some(x => x.certifications.some(y => y === "fairtrade"));
    this.hasRainforest =  this.state.selectedCoffees.some(x => x.certifications.some(y => y === "rainforest"));

    let certifications = [];

    if(this.hasOrganic) certifications.push("organic");
    if(this.hasFairtrade) certifications.push("fairtrade");
    if(this.hasRainforest) certifications.push("rainforest");
    let numberOfCertifications = 0;

    let certificationSize = 12;

    let newOffsetY = this.state.customCoffees.length > 0
                     ? this.getItemYOffset(offsetY, this.state.customCoffees.filter(x => this.isOneNotNull(x.oneSize, x.s, x.m,x.l)).length) + 5
                     : offsetY;
    let textHeight = 0;

    this.state.selectedCoffees.map(coffee => {

      newOffsetY = this.addTextTitle(
        newOffsetY - this.config.topPadding,
        coffee.name,
        coffee.description.replace(/(<([^>]+)>)/gi, ""),
        true) ;

    });


    if(this.state.hasCertifications.value !== "false") {
      certifications.forEach(certification => {
        switch(certification) {
          case "fairtrade":
            this.doc.addImage(menuBuilderSettings.fairtradeLogo.url, "",
            this.pageOffset() + this.config.positions.items + numberOfCertifications++ * (certificationSize + 5),
            newOffsetY - 3 , certificationSize, 140 / 119 * certificationSize)
            break;
          case "organic":
            this.doc.addImage(menuBuilderSettings.organicLogo.url, "",
            this.pageOffset() + this.config.positions.items + numberOfCertifications++ * (certificationSize + 5),
            newOffsetY , certificationSize, 125 / 209 * certificationSize);

            break;
          case "rainforest":
            this.doc.addImage(menuBuilderSettings.rainforestLogo.url, "",
            this.pageOffset() + this.config.positions.items + numberOfCertifications++ * (certificationSize + 5),
            newOffsetY - 2  , certificationSize * 2, 158 / 380 * certificationSize * 2)
            break;
        }
      })



      let hasCertif = (this.hasFairtrade || this.hasOrganic || this.hasRainforest);
      return newOffsetY + hasCertif * certificationSize + hasCertif * 5 ;
    }

    return newOffsetY;// + 5;

  },

  addSection(offsetY, items, title) {
    offsetY = this.checkAddPage(offsetY, 20);

    this.setTitle(this.getYPosition(offsetY), title)

    this.doc.setFont("regular")
    this.doc.setFontSize(this.config.fontSizes.text)

    let additionalIndex = 0;

    items.filter(x => this.isOneNotNull(x.price)).map((item, index) => {
      additionalIndex += this.writeProduct(item, this.getItemYOffset(offsetY, index + additionalIndex / 2))
    })

    return this.getItemYOffset(offsetY, items.filter(x => this.isOneNotNull(x.price)).length + additionalIndex / 2) ;
  },


  addOtherSection(offsetY) {
    offsetY = this.checkAddPage(offsetY, 30);
    this.setTitle(this.getYPosition(offsetY), this.state.otherTitle.value.toUpperCase())

    this.doc.setFont("regular")
    this.doc.setFontSize(this.config.fontSizes.text)

    this.state.others.map((item, index) => {
      this.writeOtherProduct(item, this.getOtherItemYOffset(offsetY, index))
    })

    return this.getOtherItemYOffset(offsetY, this.state.others.length) ;
  },

  addTextTitle(offsetY, title, text, smallTitle, noNewPage = false) {

    const splitText = this.doc.splitTextToSize(text, this.config.textMaxWidth);

    offsetY = this.checkAddPage(offsetY, splitText.length * this.config.fontSizes.smallText / 2)

    if(smallTitle) {
      this.setTitle(this.getYPosition(offsetY), title.toUpperCase())
    } else {
      this.setBigTitle(this.getYPosition(offsetY), title.toUpperCase())
    }

    this.doc.setFont("regular")
    this.doc.setFontSize(this.config.fontSizes.smallText)

    const textPosition = this.getYPosition(offsetY + this.config.fontSizes.title * .65);

    this.doc.setFontSize(this.config.fontSizes.smallText)

    this.doc.text(splitText, this.pageOffset() + this.config.positions.items , textPosition)

    if(!noNewPage) {
      return this.getYPosition(offsetY +
        this.config.fontSizes.title +
        this.config.fontSizes.smallText * splitText.length * .5)
    } else {
      return 0;
    }

  },

  addCoffeesSection(offsetY) {

    let position = offsetY;
    this.state.selectedCoffees.map((coffee, index) => {
      position = this.checkAddPage(position - this.config.topPadding + 5, 30);
      position = this.addTextTitle(
        position,
        coffee.name,
        coffee.description.replace(/(<([^>]+)>)/gi, ""),
        false) ;


    })

    return this.getYPosition(position)

  },

  addCertificationsSection(offsetY) {

    if (!this.hasFairtrade && !this.hasOrganic && !this.hasRainforest) {
      return;
    }
    offsetY = this.checkAddPage(offsetY, 30);

    this.setTitle(this.getYPosition(offsetY), "CERTIFICATIONS")

    let isFirst = true;

    if(this.hasOrganic) {
      offsetY = this.addTextTitle(
        offsetY + isFirst * this.config.fontSizes.text ,
        "Organic",
        this.state.texts.organic,
        false) - this.config.topPadding;

        isFirst = false;

        offsetY = this.checkAddPage(offsetY);
    }

    if(this.hasFairtrade) {
      offsetY = this.addTextTitle(
        offsetY + isFirst * this.config.fontSizes.text,
        "Fairtrade",
        this.state.texts.fairtrade,
        false) - this.config.topPadding

        isFirst = false;

        offsetY = this.checkAddPage(offsetY);
    }

    if (this.hasRainforest) {
      this.addTextTitle(
        offsetY + isFirst * this.config.fontSizes.text,
        "Rainforest Alliance",
        this.state.texts.rainforest,
        false, true)
    }



  },

  /**
   * Calculates the Y position of product
   * @param {*} offsetY
   * @param {*} index
   */
  getItemYOffset(offsetY, index) {
    const offset = offsetY + this.config.fontSizes.sectionSpacing +
                   (index) * this.config.fontSizes.lineSpacing;

    return this.getYPosition(offset);
  },

  getOtherItemYOffset(offsetY, index) {
    const offset = offsetY + this.config.fontSizes.sectionSpacing +
    (index) * this.config.fontSizes.lineSpacing * 2 ;

    return this.getYPosition(offset);
  },

  getYPosition(offsetY) {
    let position = offsetY % this.config.innerHeight + this.config.topPadding

    const pageAdded = position < this.lastPosition

    if(pageAdded) {
      this.addPage()
      this.addLogos(false)
    }

    this.lastPosition = position

    return position
  },

  addPage() {
    this.rightPage = this.pageCounter++ % 2 != 0;

    if(!this.rightPage) {
      this.doc.addPage();
    }
  },

  checkAddPage(valueToReset, offsetToCheck = 0) {

    if(this.lastPosition + offsetToCheck >= this.config.innerHeight) {
      this.lastPosition = 0
      this.addPage()
      this.addLogos(false)
      return 0
    }
    return valueToReset
  },

  /**
   * Sets a title for a section
   * @param {*} positionY
   * @param {*} title
   */
  setTitle(positionY, title) {
    this.doc.setFont("bold")
    this.doc.setFontSize(this.config.fontSizes.title)
    this.doc.text(title, this.pageOffset() + this.config.positions.items, positionY)
  },

  setBigTitle(positionY, title) {
    this.doc.setFont("bold")
    this.doc.setFontSize(this.config.fontSizes.bigTitle)
    this.doc.text(title, this.pageOffset() + this.config.positions.items, positionY)
  },

  /**
   * Formats a price with a £ sign - removed for now
   * @param {*} price
   */
  prettyPrice(price) { return price != "" ? `${price}` : `` } ,

  /**
   * Writes a custom coffee line at a specific place
   * @param {*} coffee
   * @param {*} offsetY
   */
  writeCoffee(coffee, offsetY) {
    this.doc.text(coffee.name, this.pageOffset() + this.config.positions.items, offsetY)
    this.doc.text(this.prettyPrice(coffee.oneSize), this.pageOffset() + this.config.positions.price1, offsetY)
    this.doc.text(this.prettyPrice(coffee.s), this.pageOffset() + this.config.positions.price2, offsetY)
    this.doc.text(this.prettyPrice(coffee.m), this.pageOffset() + this.config.positions.price3, offsetY)
    this.doc.text(this.prettyPrice(coffee.l), this.pageOffset() + this.config.positions.price4, offsetY)




  },

  /**
   * Writes a product at a specific place
   * @param {*} product
   * @param {*} offsetY
   */
  writeProduct (product, offsetY) {
    this.doc.setFontSize(this.config.fontSizes.text)

    const splitText = this.doc.splitTextToSize(product.name, this.config.textMaxWidth - 30);

    this.doc.text(splitText, this.pageOffset() + this.config.positions.items, offsetY, {lineHeightFactor: 1.3})
    this.doc.text(this.prettyPrice(product.price), this.pageOffset() + this.config.positions.price4, offsetY)

    this.doc.setFontSize(this.config.fontSizes.smallText)

    let additionalIndex = splitText.length - 1;

    if(product.description !== undefined) {
      const splitTextDesc = this.doc.splitTextToSize(product.description, this.config.textMaxWidth - 30);
      this.doc.text(splitTextDesc, this.pageOffset() + this.config.positions.items, offsetY + (this.config.fontSizes.smallText / 2) * splitText.length);
      additionalIndex += splitTextDesc.length;
    }


    return additionalIndex;

  },


  writeOtherProduct (product, offsetY) {
    this.doc.setFontSize(this.config.fontSizes.text)

    this.doc.text(product.name, this.pageOffset() + this.config.positions.items, offsetY)
    this.doc.text(this.prettyPrice(product.price), this.pageOffset() + this.config.positions.price4, offsetY)

    this.doc.setFontSize(this.config.fontSizes.smallText)

    this.doc.text(product.description, this.pageOffset() + this.config.positions.items, offsetY + this.config.fontSizes.smallText / 2)

  }

};



// WEBPACK FOOTER //
// ./scripts/vue/services/pdf.service.js